/* 🤖 this file was generated by svg-to-ts */
export const sbIconsCheck: {
  name: 'check';
  data: string;
} = {
  name: 'check',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><path fill="currentColor" d="M12.7022 2.2735a.92495.92495 0 0 0-1.0125-.20248.925.925 0 0 0-.301.20248L4.49734 9.17409 1.60205 6.26955a.9453.9453 0 0 0-1.03356-.18706.9452.9452 0 0 0-.50266.52036.9453.9453 0 0 0 .2227 1.02647l3.55205 3.55208a.924.924 0 0 0 .30102.2024.9244.9244 0 0 0 .71148 0 .924.924 0 0 0 .30102-.2024l7.5481-7.54814a.926.926 0 0 0 .2201-.30876A.926.926 0 0 0 13 2.95338a.926.926 0 0 0-.0777-.37112.926.926 0 0 0-.2201-.30876"/></svg>`
};
